import React, { useContext } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { ButtonContinue } from '../../../common/Button/ButtonContinue';
import List from '../../../common/Widgets/List';
import Card from '../../../common/Widgets/Card';
import { SiteContext } from '../../../../context/SiteContext';
import {
  InsuranceJourneyContext,
  InsuranceJourneyState
} from '../../../common/CommonTypes';
import useCarInsuranceController from '../../../../hooks/insuranceJourney/useCarInsuranceController';
import { getStartQuotePath } from '../InsuranceMethods';
import { useErrorBoundary } from 'react-error-boundary';

const OriginalLandingPage = (): JSX.Element => {
  const navigate = useNavigate();
  const { showBoundary } = useErrorBoundary();

  const { site } = useContext(SiteContext);

  const { pageEvents } = useOutletContext<InsuranceJourneyContext>();

  const { commonEvents } = pageEvents;

  const { setQuote } = commonEvents;

  const { getNewQuote } = useCarInsuranceController();

  const getNewQuoteSuccess = (quote: InsuranceJourneyState) => {
    setQuote({
      ...quote,
      tiaProductCode: site.brand.tiaProductCode
    });

    navigate(
      getStartQuotePath(
        site.user.isDealer ?? false,
        site.brand.useAlternateEligibility
      )
    );
  };

  const onBackendFailure = (err: string) => {
    showBoundary(new Error(err));
  };

  const getStarted = () => {
    getNewQuote(
      '',
      site.user?.insuranceDealerCode ?? '',
      site.user.token,
      getNewQuoteSuccess,
      onBackendFailure
    );
  };

  const leftCoverItems: string[] = [
    'Comprehensive cover',
    'Courtesy car as standard',
    '24-hour accident recovery',
    'Cover to drive in the European Union',
    'Child seat replacement cover'
  ];

  const rightCoverItems: string[] = [
    'Replacement lock cover',
    'Windscreen damage cover',
    'Audio, Satnav and car equipment cover',
    'Personal possessions cover',
    'Medical cover'
  ];

  return (
    <div className='insurance-landing-page primary-section'>
      <div className='hero-image'>
        <div className='image-overlay'>
          <h1>Finding the insurance that's right for you...</h1>
          <ButtonContinue
            name='btnGetStarted'
            text='Get a quote'
            onClick={getStarted}
            additionalClassNames='btn-hero-start'
          />
          <div className='feefologo'></div>
        </div>
      </div>
      <div className='centered-section'>
        <h3>Great value Insurance that's personal</h3>
        <h2>
          We work harder to provide car insurance that suits your needs and your
          lifestyle. After all if we were all the same, the world would be a
          duller place.
        </h2>
        <h5>Discover Something Original</h5>
      </div>
      <div className='flex-row justify-center secondary-section'>
        <div className='margin-panel'>
          <div className='flex-row tertiary-section'>
            <div className='flex-row cards'>
              <div className='whycard'>
                <div className='feefologo'></div>
              </div>
              <div className='whycard'>
                <Card
                  id='why2'
                  title={'Over \n1.2 Million'}
                  description='Customer policies issued in the last ten years.'
                />
              </div>
              <div className='whycard'>
                <Card
                  id='why3'
                  title='UK-based Call Centres'
                  description='Here for you if you make a claim, day or night, 24/7'
                />
              </div>
            </div>
            <h2>
              We also work with some of the biggest car brands in the world;
              operating their customer insurance programmes.
            </h2>
            <ButtonContinue
              name='btnGetStarted2'
              text='Get a quote'
              onClick={getStarted}
              additionalClassNames='btn-start'
            />
          </div>
          <div className='flex-row justify-center'>
            <h3>
              We make sure you have <br />
              the cover you need!
            </h3>
            <div className='flex-row'>
              <div className='two-columns'>
                <List id='left-cover' listItems={leftCoverItems} />
              </div>
              <div className='two-columns'>
                <List id='right-cover' listItems={rightCoverItems} />
              </div>
            </div>
            <ButtonContinue
              name='btnGetStarted3'
              text='Get a quote'
              onClick={getStarted}
              additionalClassNames='btn-start'
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OriginalLandingPage;
